import { TablePagination } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import useDonations from "../../../hooks/useDonations";
import Emptystate from "../emptystate/emptystate";
import Spinner from "../spinner/spinner";
import classes from "./donationtable.module.css";

const DonationTable = () => {
   const { getDonations, getDonationTypes } = useDonations();

   const {
      donations: { donationResponse, getLoading, donationTypes },
   } = useSelector((state) => state);

   const handleChangePage = (_, newPage) => {
      getDonations({
         pageSize: donationResponse?.pageable?.pageSize,
         pageNo: newPage,
      });
   };

   const handleChangeRowsPerPage = (event) => {
      getDonations({ pageSize: event.target.value, pageNo: 0 });
   };

   useEffect(() => {
      const identifier = setTimeout(() => {
         getDonationTypes();
      }, 1);

      return () => {
         clearTimeout(identifier);
      };
   }, []);

   const filterDonationTypes = (id) =>
      donationTypes?.length > 0 &&
      donationTypes?.find((data) => data.id === id);

   return (
      <>
         <TableContainer
            component={Paper}
            sx={{ maxHeight: "60vh", maxWidth: "90vw" }}
         >
            {getLoading ? (
               <Spinner />
            ) : (
               donationResponse?.content &&
               donationResponse?.content?.length > 0 && (
                  <Table stickyHeader aria-label="sticky table">
                     <TableHead>
                        <TableRow className={classes.table_row}>
                           <TableCell className={classes.table_cell}>
                              Username
                           </TableCell>
                           <TableCell className={classes.table_cell}>
                              Full Name
                           </TableCell>
                           <TableCell className={classes.table_cell}>
                              Phone number
                           </TableCell>
                           <TableCell className={classes.table_cell}>
                              Amount Donated
                           </TableCell>
                           <TableCell className={classes.table_cell}>
                              channel
                           </TableCell>
                           <TableCell className={classes.table_cell}>
                              Donation Type
                           </TableCell>
                           <TableCell className={classes.table_cell}>
                              Payment Mode
                           </TableCell>
                        </TableRow>
                     </TableHead>
                     <TableBody>
                        <>
                           {donationResponse.content.map((donation) => (
                              <TableRow
                                 key={donation.id}
                                 sx={{
                                    "&:last-child td, &:last-child th": {
                                       border: 0,
                                    },
                                 }}
                              >
                                 <TableCell
                                    component="th"
                                    scope="row"
                                    style={{ minWidth: 150 }}
                                 >
                                    {donation.userDetails.username}
                                 </TableCell>
                                 <TableCell
                                    component="th"
                                    scope="row"
                                    style={{ minWidth: 300 }}
                                 >
                                    {donation.userDetails.fullName}
                                 </TableCell>
                                 <TableCell
                                    component="th"
                                    scope="row"
                                    style={{ minWidth: 150 }}
                                 >
                                    {donation.userDetails.phoneNumber}
                                 </TableCell>
                                 <TableCell style={{ minWidth: 200 }}>
                                    {donation.amount}
                                 </TableCell>

                                 <TableCell style={{ minWidth: 200 }}>
                                    {donation.description}
                                 </TableCell>
                                 <TableCell style={{ minWidth: 200 }}>
                                    {filterDonationTypes(
                                       donation.donationTypeId
                                    )?.name?.toUpperCase()}
                                 </TableCell>
                                 <TableCell style={{ minWidth: 200 }}>
                                    {donation.paymentMode}
                                 </TableCell>
                              </TableRow>
                           ))}
                        </>
                     </TableBody>
                  </Table>
               )
            )}
         </TableContainer>
         {!getLoading &&
            donationResponse?.content &&
            donationResponse?.content?.length > 0 && (
               <TablePagination
                  count={donationResponse.totalElements ?? 0}
                  shape="rounded"
                  page={donationResponse?.pageable?.pageNumber ?? 0}
                  rowsPerPage={donationResponse?.pageable?.pageSize ?? 10}
                  className={classes.pagination}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
               />
            )}
         {!getLoading &&
            (!donationResponse?.content ||
               donationResponse?.content?.length === 0) && (
               <Emptystate name="donations" />
            )}
      </>
   );
};

export default DonationTable;
